import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApploadServiceService } from 'projects/hp-api/src/lib/services/appload-service.service';
import { MatDialog } from '@angular/material/dialog';
import { FacebookService, InitParams, UIParams, UIResponse } from 'ngx-facebook';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SocialMediasComponent } from '.././dialogs/social-medias/social-medias.component';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { of } from 'rxjs';
//declare function matomo(): void;
//declare function trackEvent(): void;
//declare function bingAds(): void;

interface DataSave {
  photo_name: string;
  pdf_name: string;
}
const httpoptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*' })
}
const numericNumberReg= '^-?[0-9]\\d*(\\.\\d{1,2})?$';
const numberPhoneReg = '^(?:(?:(?:\\+|00)33[ ]?(?:\\(0\\)[ ]?)?)|0){1}[1-9]{1}([ .-]?)(?:\\d{2}\\1?){3}\\d{2}$';
declare var gtag;

@Component({
  selector: 'app-finaliser',
  templateUrl: './finaliser.component.html',
  styleUrls: ['./finaliser.component.scss']
})
export class FinaliserComponent extends WizardHpBaseComponent implements OnInit {
  devisForm: FormGroup;
  mat_stepper_width = 340;
  etape_show = false;
  name = 'ngx sharebuttons';
  lastData = [{
    "photo": "",
    "pdf": ""
  }];
  pdf_link = "";
  photo_link = "";
  href_iframe = "";
  screenProject: any;
  dataPdf: any;
  public hasSent = false;
  public beforeSending = false
  popSubmitted = false;
  submitted = false;
  changeText = false;
  public cwData :any;
  typeDemandesData = [];
  selectedTypeDemande = false;
contenEmail :any;
  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService,  
    public dialog: MatDialog,
    private fileUploadService: ApploadServiceService, router: Router,
    public formb: FormBuilder,
    private http: HttpClient,
    private fb: FacebookService,

    private _bottomSheet: MatBottomSheet) {
      super(chgDetectorRef, hpService, router);

    this.getHpService().setHeaderIn(true);
    this.getHpService().setCurrentPage(this.getIndexNextUrl('simulateur-finalisation'))
    this.getHpService().setEtape_final(true);

    if (!this.getHpService().currentProduct) {
      this.getRouter().navigate([this.getHpService().getConfig().nav[0].link]);
    }
    this.devisForm = this.formb.group({
      gender: ['',Validators.required],
      typeDemandes: new FormArray([],this.minSelectedCheckboxes(1)),
      title: [''],
      name: ['', Validators.required],
      prenom: ['', Validators.required],
      email: ['', [Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      tel: ['', [Validators.required,Validators.pattern(numberPhoneReg)]],
      adresse: ['', Validators.required],
      cp: ['', [Validators.required,Validators.pattern(numericNumberReg),Validators.minLength(5),Validators.maxLength(5)]],
      ville: ['', Validators.required],
      comment: [''],
      acceptTerms: [false,Validators.required]

    });
      // type demandes
      of(this.getTypeDemande()).subscribe(data => {
        this.typeDemandesData = data;
        this.addCheckboxes();
      });

    this.lastData = [];
    this.screenProject = this.getHpService().getbase64String();
    this.href_iframe = this.getHpService().getHref_iframe();
   /* switch(this.getHpService().getConfig().herculepro.slug)
    {
      case "janneau":
                   // matomo();
                    break;
    }*/

  }

  ngOnInit() {
    this.initAutocomplete();
    setTimeout(() => {
      this.mat_stepper_width = this.mat_stepper_width + 165;
      this.etape_show = true;
    }, 1000);

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    
  }
  openBottomSheet(): void {
    this._bottomSheet.open(SocialMediasComponent);
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  toLink(url) {

    this.getRouter().navigate([url]);
  }
  getValidator() {
    return this.devisForm.invalid;
  }


  private addCheckboxes() {
    this.typeDemandesData.forEach(() => this.typeDemandeFormArray.push(new FormControl(false)));
  }
  getTypeDemande()
  {
    return [ { id: 1, libelle: 'Avoir un contact avec un conseiller' },
    { id: 2, libelle: 'Obtenir un devis' },
    { id: 3, libelle: 'Télécharger mon projet' }]

  }
  public myError = (controlName: string, errorName: string) =>{
    return this.devisForm.controls[controlName].hasError(errorName);
   
    }
  get f() { return this.devisForm.controls; }  

  get typeDemandeFormArray() {
    return this.devisForm.controls.typeDemandes as FormArray;
  }
  get typeDemandeFormArraySelectedIds(): string[] {
    return this.typeDemandesData
      .filter((cat, catIdx) => this.typeDemandeFormArray.controls.some((control, controlIdx) => catIdx === controlIdx && control.value))
      .map(cat => cat.libelle);
  }
  

  submitForm() {
    this.submitted = true;
    const selectedOrderIds = this.devisForm.value.typeDemandes
    .map((checked, i) => checked ? this.typeDemandesData[i].id : null)
    .filter(v => v !== null);
    this.selectedTypeDemande = selectedOrderIds.length > 0;
    console.log(this.devisForm.value.gender);
    console.log(!(this.devisForm.value.acceptTerms) )
    if (this.devisForm.invalid || !(this.devisForm.value.acceptTerms) || (this.devisForm.value.gender === '') || this.typeDemandeFormArraySelectedIds.length === 0) {
      this.popSubmitted = true;
      return;
    }
    this.sendMail();
  }

 minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const typeSelected = formArray.controls
        .map(control => control.value)
        .reduce((prev, next) => next ? prev + next : prev, 0);
  
      return typeSelected >= min ? null : { required: true };
    };
  
    return validator;
  }
  

  sendMail() {
    // Simple POST request with a JSON body and response type <any>
    debugger;
    this.beforeSending = true;
    var currentData = this.getHpService().getCurrentSimulationData();
    var re = /,/gi; 
    var choix_type_demande = (this.typeDemandeFormArraySelectedIds.toString()).replace(re, ", ");;
    var formData =
    {
      "CLI_NOM": this.getHpService().getSlug(),
      "civilite": this.devisForm.value.gender,
      "type_de_demande":choix_type_demande,
      "titre": this.devisForm.value.title,
      "name": this.devisForm.value.name,
      "prenom": this.devisForm.value.prenom,
      "email": this.devisForm.value.email,
      "tel": this.devisForm.value.tel,
      "adresse": this.devisForm.value.adresse,
      "cp": this.devisForm.value.cp,
      "ville": this.devisForm.value.ville,
      "comment": this.devisForm.value.comment,
      "PRODUCTS_DATA" : currentData
    }
  
    /*
    for (var i = 0; i < currentData.length; i++) {
      formData[currentData[i].code] = currentData[i].label_answer;
    }
    */
    formData["IMG_LOGO"] = this.getHpService().getAssetsFullPath() + '/assets/images/logos/'
      +'logo.png';

    var dataMenuiserie = {
      "imageData": this.getHpService().getbase64String(),
      "modelGuid": this.getHpService().getPdfModelGuid(),
      "formData": formData,
      "mailTo": this.getHpService().getConfig().formulaires.email_dest
    }
  
    var datam = this.b64EncodeUnicode(JSON.stringify(dataMenuiserie));
    this.getHpService().sendMail(datam).subscribe({
      next: (data) => {
        this.cwData = data.root;
        this.hasSent = true;
        this.beforeSending = false;
        this.getHpService().postExternalMessage('CONFIGURATION_SAVED', this.cwData);
        switch(this.getHpService().getConfig().herculepro.slug)
        {
          case "janneau":
                       // trackEvent();
                       // bingAds();
                        this.trackMe();
                        break;
        }
       
      },
      error: (error) => {
        console.log('error');
      }
    });
  }

  /**
   * 
   * @param str 
   * Encoding UTF-8 --> base64
   * @returns 
   */
   b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode(parseInt(p1, 16))
    }))
}


  trackMe() {
     gtag('event', 'conversion', {'send_to': 'AW-811626365/2RemCNLy7bADEP3egYMD'});
  }
  closeMesg(type)
  {
    switch (type)
    {
     case 'error':
      this.popSubmitted = false;
      break;
      default:
        this.submitted = false;
        this.hasSent = false;


    }
    
    
  }
  test()
  {
    return this.typeDemandeFormArraySelectedIds.toString();
  }

  /*
  Auto complete
  */

  initAutocomplete() {
    let geocoder = new google.maps.Geocoder();
    let me = this;

    const input = document.getElementById("adresse") as HTMLInputElement;
    const errorMap = document.getElementById("errorMap") as HTMLInputElement;
    const options = {
      fields: ["formatted_address", "geometry", "name"],
      strictBounds: false,
      types: ["establishment"],
    };

    let autocomplete = new google.maps.places.Autocomplete(input);
      const searchBox = new google.maps.places.SearchBox(input);

    /*Add listner to input search
    */
    autocomplete.addListener('place_changed', function () {
      let place = autocomplete.getPlace();
      if (!place.geometry) {
        //window.alert("Autocomplete's returned place contains no geometry");
        errorMap.style.display = "block";
        return;
      }
      else {
        errorMap.style.display = "none";

      }
    });

    searchBox.addListener("places_changed", () => {
      const places = searchBox.getPlaces();


      if (places.length == 0) {

        return;
      };
      geocoder.geocode({
        'address': input.value
      }, function (results, status) {


        if (status == 'OK') {


          console.log(results[0].address_components);
          let street_numberIndex = me.getTypeAdress_compents(results[0].address_components,"street_number");
          let routeIndex = me.getTypeAdress_compents(results[0].address_components,"route");
          let localityIndex = me.getTypeAdress_compents(results[0].address_components,"locality");
          let postal_codeIndex = me.getTypeAdress_compents(results[0].address_components,"postal_code");
          me.devisForm.controls['adresse'].setValue(results[0].address_components[street_numberIndex].long_name+" "+ results[0].address_components[routeIndex].long_name);
          me.devisForm.controls['ville'].setValue(results[0].address_components[localityIndex].long_name);
          me.devisForm.controls['cp'].setValue(results[0].address_components[postal_codeIndex].long_name);
        } else {
          alert('Geocode was not successful for the following reason: ' + status);

        }
      });

    });




  }

  /***
   * Get type  Google address_components
   */

  getTypeAdress_compents(address_components:any,name:any)
  {
   
    for (var i = 0; i < address_components.length; i++) {
      const typeName = (element) => element  === name;

      if (address_components[i].types.findIndex(typeName) !== -1) {
        
        return i;

        }
    }
    
  }

  checkPatern(paternValidator:any) {
    if(paternValidator)
    {
      return paternValidator.hasOwnProperty('pattern')
    }
   
  }
  formatNumberPhone(value) {
   
    this.devisForm.value.tel = value.toString().replace(/\B(?=(\d{2})+(?!\d))/g, " ")
    }


  /*    this.devisForm.reset();
    Object.keys(this.devisForm.controls).forEach(key => {
    this.devisForm.get(key).setErrors(null) ;
  });*/
}
